import { useGetVietnamProvinceQuery } from '@/store/api/vietnam-province.api';

import * as R from 'ramda';

export const getProvinceOptions = (provinces: any[]) => {
	return R.map(R.pick(['id', 'name', 'type']), provinces).map(
		({ id, name, type }: any) => ({
			id,
			question: `${type === 1 ? 'TP.' : 'Tỉnh'} ${name}`,
		})
	);
};

export const useGetProvinces = () => {
	const { data } = useGetVietnamProvinceQuery(100);
	return data?.data || [];
};
